/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "overmorgen",
        "future": {
          "one": "over {0} dag",
          "other": "over {0} dagen"
        },
        "past": {
          "one": "{0} dag geleden",
          "other": "{0} dagen geleden"
        }
      },
      "day-narrow": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "overmorgen",
        "future": {
          "one": "over {0} dag",
          "other": "over {0} dgn"
        },
        "past": {
          "one": "{0} dag geleden",
          "other": "{0} dgn geleden"
        }
      },
      "day-short": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "overmorgen",
        "future": {
          "one": "over {0} dag",
          "other": "over {0} dgn"
        },
        "past": {
          "one": "{0} dag geleden",
          "other": "{0} dgn geleden"
        }
      },
      "hour": {
        "0": "binnen een uur",
        "future": {
          "one": "over {0} uur",
          "other": "over {0} uur"
        },
        "past": {
          "one": "{0} uur geleden",
          "other": "{0} uur geleden"
        }
      },
      "hour-narrow": {
        "0": "binnen een uur",
        "future": {
          "one": "over {0} uur",
          "other": "over {0} uur"
        },
        "past": {
          "one": "{0} uur geleden",
          "other": "{0} uur geleden"
        }
      },
      "hour-short": {
        "0": "binnen een uur",
        "future": {
          "one": "over {0} uur",
          "other": "over {0} uur"
        },
        "past": {
          "one": "{0} uur geleden",
          "other": "{0} uur geleden"
        }
      },
      "minute": {
        "0": "binnen een minuut",
        "future": {
          "one": "over {0} minuut",
          "other": "over {0} minuten"
        },
        "past": {
          "one": "{0} minuut geleden",
          "other": "{0} minuten geleden"
        }
      },
      "minute-narrow": {
        "0": "binnen een minuut",
        "future": {
          "one": "over {0} min.",
          "other": "over {0} min."
        },
        "past": {
          "one": "{0} min. geleden",
          "other": "{0} min. geleden"
        }
      },
      "minute-short": {
        "0": "binnen een minuut",
        "future": {
          "one": "over {0} min.",
          "other": "over {0} min."
        },
        "past": {
          "one": "{0} min. geleden",
          "other": "{0} min. geleden"
        }
      },
      "month": {
        "-1": "vorige maand",
        "0": "deze maand",
        "1": "volgende maand",
        "future": {
          "one": "over {0} maand",
          "other": "over {0} maanden"
        },
        "past": {
          "one": "{0} maand geleden",
          "other": "{0} maanden geleden"
        }
      },
      "month-narrow": {
        "-1": "vorige maand",
        "0": "deze maand",
        "1": "volgende maand",
        "future": {
          "one": "over {0} maand",
          "other": "over {0} maanden"
        },
        "past": {
          "one": "{0} maand geleden",
          "other": "{0} maanden geleden"
        }
      },
      "month-short": {
        "-1": "vorige maand",
        "0": "deze maand",
        "1": "volgende maand",
        "future": {
          "one": "over {0} maand",
          "other": "over {0} maanden"
        },
        "past": {
          "one": "{0} maand geleden",
          "other": "{0} maanden geleden"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "vorig kwartaal",
        "0": "dit kwartaal",
        "1": "volgend kwartaal",
        "future": {
          "one": "over {0} kwartaal",
          "other": "over {0} kwartalen"
        },
        "past": {
          "one": "{0} kwartaal geleden",
          "other": "{0} kwartalen geleden"
        }
      },
      "quarter-narrow": {
        "-1": "vorig kwartaal",
        "0": "dit kwartaal",
        "1": "volgend kwartaal",
        "future": {
          "one": "over {0} kw.",
          "other": "over {0} kw."
        },
        "past": {
          "one": "{0} kw. geleden",
          "other": "{0} kw. geleden"
        }
      },
      "quarter-short": {
        "-1": "vorig kwartaal",
        "0": "dit kwartaal",
        "1": "volgend kwartaal",
        "future": {
          "one": "over {0} kwart.",
          "other": "over {0} kwart."
        },
        "past": {
          "one": "{0} kwart. geleden",
          "other": "{0} kwart. geleden"
        }
      },
      "second": {
        "0": "nu",
        "future": {
          "one": "over {0} seconde",
          "other": "over {0} seconden"
        },
        "past": {
          "one": "{0} seconde geleden",
          "other": "{0} seconden geleden"
        }
      },
      "second-narrow": {
        "0": "nu",
        "future": {
          "one": "over {0} sec.",
          "other": "over {0} sec."
        },
        "past": {
          "one": "{0} sec. geleden",
          "other": "{0} sec. geleden"
        }
      },
      "second-short": {
        "0": "nu",
        "future": {
          "one": "over {0} sec.",
          "other": "over {0} sec."
        },
        "past": {
          "one": "{0} sec. geleden",
          "other": "{0} sec. geleden"
        }
      },
      "week": {
        "-1": "vorige week",
        "0": "deze week",
        "1": "volgende week",
        "future": {
          "one": "over {0} week",
          "other": "over {0} weken"
        },
        "past": {
          "one": "{0} week geleden",
          "other": "{0} weken geleden"
        }
      },
      "week-narrow": {
        "-1": "vorige week",
        "0": "deze week",
        "1": "volgende week",
        "future": {
          "one": "over {0} week",
          "other": "over {0} weken"
        },
        "past": {
          "one": "{0} week geleden",
          "other": "{0} weken geleden"
        }
      },
      "week-short": {
        "-1": "vorige week",
        "0": "deze week",
        "1": "volgende week",
        "future": {
          "one": "over {0} week",
          "other": "over {0} weken"
        },
        "past": {
          "one": "{0} week geleden",
          "other": "{0} weken geleden"
        }
      },
      "year": {
        "-1": "vorig jaar",
        "0": "dit jaar",
        "1": "volgend jaar",
        "future": {
          "one": "over {0} jaar",
          "other": "over {0} jaar"
        },
        "past": {
          "one": "{0} jaar geleden",
          "other": "{0} jaar geleden"
        }
      },
      "year-narrow": {
        "-1": "vorig jaar",
        "0": "dit jaar",
        "1": "volgend jaar",
        "future": {
          "one": "over {0} jaar",
          "other": "over {0} jaar"
        },
        "past": {
          "one": "{0} jaar geleden",
          "other": "{0} jaar geleden"
        }
      },
      "year-short": {
        "-1": "vorig jaar",
        "0": "dit jaar",
        "1": "volgend jaar",
        "future": {
          "one": "over {0} jaar",
          "other": "over {0} jaar"
        },
        "past": {
          "one": "{0} jaar geleden",
          "other": "{0} jaar geleden"
        }
      }
    },
    "locale": "nl-SX"
  });
}